import React from 'react';

import PercentageProgressListItem from '/component/base/PercentageProgressListItem';

interface NumericDataProps {
  data: {
    current: any;
    target: any;
  };
  getTitle: () => string;
  isComplete: boolean;
}

const NumericData = ({
  data: {current = 0, target = 0},
  getTitle = () => '',
  isComplete = false,
}: NumericDataProps) => {
  const isMaxTarget = Math.floor(current) > Math.floor(target);
  return (
    <PercentageProgressListItem
      denominator={parseInt(target, 10)}
      hasCheckbox
      isChecked={isComplete}
      label={getTitle()}
      numerator={isMaxTarget ? parseInt(target, 10) : parseInt(current, 10)}
      readonly
    />
  );
};

export default NumericData;
